export default "__VITE_ASSET__DBgIxcWG__"